import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-6 px-4 sm:px-6 bg-white" data-id="element-75">
      <div className="bg-brand-cream border-2 border-brand-gold/40 p-4 rounded-lg text-center shadow-md" data-id="element-76">
        <p className="text-xs font-button font-bold text-brand-rose uppercase tracking-widest mb-2" data-id="element-77">
          IL TUO INVESTIMENTO È PROTETTO AL 100%
        </p>
        <div className="w-12 h-12 mx-auto bg-brand-rose/10 rounded-full flex items-center justify-center mb-2" data-id="element-78">
          <ShieldCheck className="w-6 h-6 text-brand-rose" data-id="element-79" />
        </div>
        <h3 className="text-xl font-heading font-bold text-brand-taupe mb-2 uppercase leading-tight" data-id="element-80">
          🛡️ Garanzia Totale di 7 Giorni
        </h3>
        <p className="text-xs sm:text-sm text-brand-taupe font-medium leading-tight" data-id="element-81">
          Il tuo denaro è protetto al 100%. Hai 7 giorni completi per esplorare
          l'intero sistema, rivedere i programmi, implementare le routine e
          valutare i risultati con le tue allieve. Se per qualsiasi motivo non
          sei completamente soddisfatta, ti rimborsiamo il 100% del denaro. Zero
          rischio. Nessuna domanda richiesta.
        </p>
      </div>
    </section>;
}